import { Link } from 'components';
import NavColumn from './NavColumn';
import NavArrow from 'assets/navArrow.svg';
import ArrowUpRight from 'assets/arrowUpRight.svg';
import classNames from 'classnames';
import { useNavContext } from './NavContext';

const NavItem = ({ navItem, level, activeMenu, setActiveMenu, close, parentMenuName, dividerTop, dividerBottom }) => {
  const { isTransitioning, triggerTransition } = useNavContext();

  const _setActiveMenu = (sub) => {
    let newValue = {};
    newValue[`l${level + 1}`] = sub;
    setActiveMenu(newValue);
  };

  const handleFlyoutClick = (e) => {
    e.stopPropagation();
    if (isTransitioning()) {
      return;
    }
    triggerTransition();
    _setActiveMenu({});
  };

  const handleLinkClick = (e) => {
    if (isTransitioning()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    close();
  };

  const linkClass = classNames(
    'py-3 lg:py-2 font-montserrat text-base not-italic font-normal leading-6.5 cursor-pointer flex items-center justify-between duration-500 [&_svg]:duration-500',
    'text-black [&_svg]:fill-black',
    level === 2
      ? 'lg:hover:text-white lg:[&_svg]:hover:fill-white hover:text-black [&_svg]:hover:fill-black'
      : 'hover:text-black [&_svg]:hover:fill-black',
    activeMenu && activeMenu[`l${level + 1}`] && navItem.flyout?.length > 0
      ? level === 2
        ? 'lg:text-brand-soft-white lg:[&_svg]:fill-brand-soft-white'
        : 'lg:text-black lg:[&_svg]:fill-black'
      : level === 2
        ? 'lg:text-brand-soft-white lg:[&_svg]:fill-brand-soft-white'
        : 'lg:text-black lg:[&_svg]:fill-black',
  );

  return (
    <>
      {dividerTop && (
        <hr
          className={classNames(level === 2 ? 'lg:text-white/25' : 'lg:text-black/25', 'text-black/25 my-5 lg:my-2')}
        />
      )}
      <div>
        {navItem.flyout?.length > 0 ? (
          <div className={linkClass} onClick={handleFlyoutClick}>
            {navItem.navItemText || navItem.navigationalTitle}
            {navItem.flyout?.length > 0 && <NavArrow role="presentation" />}
          </div>
        ) : (
          <Link
            className={linkClass}
            link={
              navItem.navItemLink ||
              (navItem.ctaLink && { ...navItem.ctaLink, text: navItem.navigationalTitle || navItem.ctaLink.text })
            }
            onClick={handleLinkClick}
          >
            {navItem.navItemLink?.text || navItem.navigationalTitle || navItem.ctaLink?.text}
            {navItem.navigationText && <ArrowUpRight role="presentation" />}
          </Link>
        )}

        {(!navItem.flyout || navItem.flyout.length === 0) && !(navItem.navItemLink || navItem.ctaLink) && (
          <div className={linkClass} onClick={handleFlyoutClick}>
            {navItem.navItemText || navItem.navigationalTitle}
          </div>
        )}

        {navItem.navigationText && (
          <div className=" not-italic font-normal text-sm leading-6 lg:leading-5 lg:text-xs font-montserrat text-black lg:text-brand-soft-white mt-6">
            {navItem.navigationText}
          </div>
        )}
      </div>
      {navItem.flyout?.length > 0 && (
        <NavColumn
          navItems={navItem.flyout}
          detailedNavItems={navItem.detailedNavItems}
          level={level + 1}
          activeMenu={activeMenu}
          setActiveMenu={(sub) => _setActiveMenu(sub)}
          close={close}
          cta={navItem.flyout && navItem.flyout.length !== 0 ? navItem.navItemLink || navItem.ctaLink : null}
          ctaClass={linkClass}
          parentMenuName={level === 0 ? navItem.navItemText || navItem.navigationalTitle : parentMenuName}
        />
      )}

      {dividerBottom && (
        <hr
          className={classNames(
            level === 2 ? 'lg:text-white/25' : 'lg:text-black/25',
            'text-black/25 mt-8 lg:mt-4 mb-5 lg:mb-2',
          )}
        />
      )}
    </>
  );
};

export default NavItem;
